import React, { useState } from 'react';
import JobManagementView from './JobManagementView';
import UserManagementView from './user/UserManagementView';
import ContactManagementView from './ContactManagementView';
import CandidateProgressView from './candidate-progress/CandidateProgressView';
import WaitlistManagementView from './waitlist/WaitlistManagementView';
import ConnectionRequestQueue from './ConnectionRequestQueue';
import OpportunityManagementView from './OpportunityManagementView';
import AnalyticsDashboard from './AnalyticsDashboard';
import CompanyManagementView from './company/CompanyManagementView';

const tabs = [
  { name: 'Analytics', key: 'analytics' },
  { name: 'Candidate Progress', key: 'candidates' },
  { name: 'Connection Requests', key: 'connections' },
  { name: 'Opportunities', key: 'opportunities' },
  { name: 'Waitlist', key: 'waitlist' },
  { name: 'Users', key: 'users' },
  { name: 'Companies', key: 'companies' },
  { name: 'Jobs', key: 'jobs' },
  { name: 'Contacts', key: 'contacts' },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function AdminLayout() {
  const [currentTab, setCurrentTab] = useState('analytics'); // Default to analytics

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-6">
      {/* Tab Navigation */}
      <div className="mb-6 border-b border-gray-200 dark:border-gray-700">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setCurrentTab(tab.key)}
              className={classNames(
                tab.key === currentTab
                  ? 'border-purple-500 text-purple-600 dark:text-purple-400 font-bold'
                  : 'border-transparent text-gray-500 dark:text-gray-400 hover:border-gray-300 dark:hover:border-gray-600 hover:text-gray-700 dark:hover:text-gray-300',
                'group inline-flex items-center border-b-2 px-1 py-4 text-base md:text-lg'
              )}
              aria-current={tab.key === currentTab ? 'page' : undefined}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      </div>

      {/* Content Area */}
      <div>
        {currentTab === 'analytics' && <AnalyticsDashboard />}
        {currentTab === 'candidates' && <CandidateProgressView />}
        {currentTab === 'connections' && <ConnectionRequestQueue />}
        {currentTab === 'opportunities' && <OpportunityManagementView />}
        {currentTab === 'waitlist' && <WaitlistManagementView />}
        {currentTab === 'users' && <UserManagementView />}
        {currentTab === 'companies' && <CompanyManagementView />}
        {currentTab === 'jobs' && <JobManagementView />}
        {currentTab === 'contacts' && <ContactManagementView />}
      </div>
    </div>
  );
} 